module.exports = __webpack_public_path__ + "static/media/front_06.952db43e.png";